import { default as EditIcon } from "@mui/icons-material/Edit";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Divider,
  FilledInput,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react";
import { default as React, useCallback, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import remove from "../Assets/images/icon/denied 1.gif";
import scheduling from "../Assets/images/icon/schedule_1.gif";
import Schedule_Using_Date_Time_Frequency_2 from "../Pages/Schedule_Using_Date_Time_Frequency_2";
import apiInstance from "../apiInterceptor";
import {
  dateFormatter,
  handleApiError,
  isLatestObjectCompleted
} from "../utils";
import ShimmerLoader from "./ShimmerLoader";

const cronRegex =
  /^((\*|([0-5]?\d)(-([0-5]?\d))?)(\/([0-5]?\d)?)?)\s+((\*|([01]?[0-9]|2[0-3])(-([01]?[0-9]|2[0-3]))?)(\/([01]?[0-9]|2[0-3]))?)\s+((\*|([0-2]?[0-9]|3[0-1])(-([0-2]?[0-9]|3[0-1]))?)(\/([0-2]?[0-9]|3[0-1]))?)\s+((\*|([1-9]|1[0-2])(-([1-9]|1[0-2]))?)(\/([1-9]|1[0-2]))?)\s+((\*|[0-7]|([0-7](,[0-7])+))(\-([0-7]))?)$/;

const rowHeight = 24;
const headerHeight = 28;

const SchedulingScrapers = ({files,session,loading,ScheduleData,schedule,urlid,version,outputHistoryData,schedulechroneAPI,reschedulerAPI,cronexp,setCronExp,currentJobId,setCurrentJobId}) => {
    const [confirmSchedulePopup, setConfirmSchedulePopup] = useState(false);
    const [confirmReschedulePopup, setConfirmReschedulePopup] = useState(false);
    const [addSchedulerPopup, setAddSchedulerPopup] = useState(false);
    const [rescheduleScraper, setRescheduleScraper] = useState(false);
    const [disableSchedulerPopup, setDisableSchedulerPopup] = useState(false);
    const [selectedOption, setSelectedOption] = useState("b");
    const [currentFreqdetails, setCurrentFreqdetails] = useState({});
    const [currentFreqtype, setCurrentFreqtype] = useState("");
    
    const handleRadioChange = (event) => {
        setSelectedOption(event.target.value);
    };
    const handleCloseRescheduleScraper = () => {
      setRescheduleScraper(false);
    }
    const handleCloseSchedulerPopup = () => {
      setAddSchedulerPopup(false);
    }
    const handleClickOpendisableSchedulerPopup = (job_id) => {
        setCurrentJobId(job_id)
        setDisableSchedulerPopup(true);
    };
    const formatTooltipContent = (info) => {
        const points = info.split(";");
        return (
          <ul>
            {points.map((point, index) => (
              <li key={index}>{point.trim()}</li>
            ))}
          </ul>
        );
    };
    
    const handleClickOpenrescheduleScraper = (job_id, freq_data, freq_type) => {
        console.log(job_id)
        if (freq_type == "crone") {
          setSelectedOption("a");
        } else {
          setSelectedOption("b");
        }
        setCurrentJobId(job_id)
        setCurrentFreqdetails(freq_data)
        setCurrentFreqtype(freq_type)
        setRescheduleScraper(true);
    };
    const renderStatus = useCallback((params) => {
        return (
          <Box id="Recent_status">
            <Tooltip title={params.data.active ? (params.data.next ? "Active" : "Completed") : "Disabled"}>
              {params.data.active && params.data.next && <FiberManualRecordIcon fontSize="small" className="Complete" />}
              {params.data.active && !params.data.next && <FiberManualRecordIcon fontSize="small" className="Scheduled" />}
              {!params.data.active && <FiberManualRecordIcon fontSize="small" className="Failed" />}
            </Tooltip>
          </Box>
        );
    }, []);
    
    const renderFrequency = useCallback((params) => {
        return <Tooltip title={params.data.scheduler_freq}>{params.data.scheduler_freq}</Tooltip>;
    }, []);
    
    const renderAction = useCallback((params) => {
        return (
          <>
            <Tooltip
              style={{ marginRight: '3px' }}
              title={formatTooltipContent(params.data.info)}
              arrow
            >
              <IconButton
                className="iconbutton_comment"
              >
                <InfoOutlinedIcon fontSize="small" className="info_icon" />
              </IconButton>
            </Tooltip>
            <Tooltip style={{ marginRight: '3px' }} title="Update">
              <IconButton
                className="iconbutton_comment"
                onClick={() => {
                  if (params.data.scheduler_freq == "crone") {
                    setCronExp(params.data.chrone_expression)
    
                  } else {
    
                    setCronExp("")
                  }
    
                  handleClickOpenrescheduleScraper(params.data.job_id, params.data.freq_data, params.data.freq_type);
                }}
              >
                <EditIcon fontSize="small" className="comment_icon" />
    
              </IconButton>
            </Tooltip>
            {params.data.active && params.data.next && (
              <Tooltip title="Disable">
                <IconButton
                  className="iconbutton_comment"
                  onClick={() => {
                    handleClickOpendisableSchedulerPopup(params.data.job_id);
                  }}
                >
                  <RemoveCircleIcon fontSize="small" className="comment_icon" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
    }, []);
    
    const [colDefs_schedule] = useState([
        {
          headerName: "Actions",
          field: "",
          value: "1",
          minWidth: 60,
          flex: 1,
          cellRenderer: renderAction,
          cellStyle: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            marginLeft: 3,
            paddingLeft: 3,
            paddingTop: 0,
            marginTop: 0,
          },
        },
        {
          headerName: "Status",
          field: "",
          value: "1",
          minWidth: 40,
          flex: 1,
          cellRenderer: renderStatus,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          },
        },
        {
          headerName: "Frequency",
          field: "scheduler_freq",
          minWidth: 90,
          flex: 1,
          cellRenderer: renderFrequency,
        },
        {
          headerName: "Next Run",
          field: "next",
          minWidth: 90,
          flex: 2,
          cellRenderer: (params) => (
              <Tooltip title={dateFormatter(params.data.next)}>
                {dateFormatter(params.data.next)}
              </Tooltip>
          ),
        },
        {
          headerName: "Description",
          field: "desc", minWidth: 150, flex: 2, cellRenderer: (params) => (
              <Tooltip title={params.data.desc}>
                {params.data.desc}
              </Tooltip>
          ),
        },
    ]);

    const removeAPI_schedular = async (job_id = currentJobId, check = false) => {
        const endp = `${version}/stop-task/${job_id}?deleted_by=${session.employeeCode}`;
    
        try {
          const response = await apiInstance.delete(endp, null);
          if (response.statusText === "OK") {
            if (!check) {
              toast.success("Successfully disabled Schedular scraper");
              setTimeout(() => {
                window.location.reload()
              }, 2000);
            }
          }
        } catch (error) {
          console.error("Error sending PATCH request:", error);
          handleApiError(error)
        }
    };

    return (
    <>
        <Box className="heading_bx fx_sb_mob  ">
            <Box>
            <Typography variant="h6" className=" col1 card_title ">
                Step 3: Scheduling of Scrapers
            </Typography>
            </Box>
            <Box className="al_right">
            <Button
                className="run_scraper_btn"
                onClick={() => {
                setAddSchedulerPopup(true);
                }}
            >
                Add
            </Button>
            </Box>
        </Box>
        <Box
            className={"ag-theme-quartz  "}
            style={{ width: "100%", height: "173px" }}
        >
            {loading ? (
            <ShimmerLoader />
            ) : (
            <AgGridReact
                rowData={ScheduleData}
                columnDefs={colDefs_schedule}
                rowHeight={rowHeight}
                headerHeight={headerHeight}
                filter={true}
                enableCellTextSelection={true}
            />
            )}
        </Box>

        {/* Scheduling of Scraper */}
        <Box className="data preview" >
        <Dialog
          open={addSchedulerPopup}
          onClose={handleCloseSchedulerPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent sx={{ position: "relative" }}>
            <Box sx={{ mt: 2 }} className="whitebx2 no-shadow schedule">
              <Box className="heading_bx fx_sb_mob" >
                <Box className="">
                  <Typography variant="h6" className=" col1 card_title ">
                    Scheduling of Scraper
                  </Typography>
                </Box>
                <Box>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={selectedOption}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="b"
                        control={<Radio />}
                        label="Using Date, Time & Frequency"
                      />
                      <FormControlLabel
                        value="a"
                        control={<Radio />}
                        label="Using Cron Expression"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
              {
                selectedOption === "a" ? (
                  <Box className="cron_expression" my={2}>
                    <Grid container justifyContent="center" spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <FormControl fullWidth className="input_field">
                          <FilledInput
                            className="textfield_cron"
                            id="filled-adornment-password"
                            placeholder="Enter Cron Expression"
                            onChange={(event) => {
                              setCronExp(event.target.value);
                            }}
                          />
                        </FormControl>
                        <Box mt={1} className="al_left">
                          <Typography variant="h6" className="gray desc">
                            {" "}
                            Note: A cron expression is a string
                            representing a schedule in a time-based job
                            scheduling system (like Unix cron). It is
                            typically made up of five or six fields,
                            separated by space, that represent different
                            units of time.
                          </Typography>

                          <Typography
                            variant="h6"
                            className="xstext"
                            mt={1}
                          >
                            {" "}
                            Example: A cron expression 0 12 * * Mon means
                            the task will run at 12:00 PM every Monday.
                            Learn more{" "}
                            <a
                              href="https://crontab.guru/"
                              className="a_underline"
                              target="_blank"
                            >
                              click here
                            </a>
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Box className="bottom-fixed-stack">
                      <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="flex-end">

                        <Button
                          className="approve_btn"
                          disabled={!schedule || !cronRegex.test(cronexp)}
                          onClick={() => {
                            setConfirmSchedulePopup(true);
                          }}
                        >
                          Schedule
                        </Button>

                        <Button
                          className="cancel_btn"
                          onClick={() => {
                            setAddSchedulerPopup(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Stack>
                    </Box>
                  </Box>
                ) : (
                  <Schedule_Using_Date_Time_Frequency_2
                    urlid={urlid}
                    schedule_flag={schedule}
                    emp_code={session ? session.employeeCode : null}
                    reschedule_flag={true}
                    version={version}
                    add_flag={true}
                    all_desc={ScheduleData}
                    // freq_details={details.frequency_data}
                    //       freq_type={details.frequency_type}
                    pageType="approved2"
                    allowed={
                      files.some((file) => file.status == "approved") &&
                      isLatestObjectCompleted(outputHistoryData)
                    }
                    onClickHandle={handleCloseSchedulerPopup}
                  // allowed={true}
                  />
                )

              }
            </Box>
          </DialogContent>
        </Dialog>
        </Box >

        {/* Re-schedule pop-up */}

        <Box className="comment">
        <Dialog
          open={rescheduleScraper}
          onClose={handleCloseRescheduleScraper}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          fullWidth
        >
          <DialogContent sx={{ position: "relative" }}>
            <Box sx={{ mt: 2 }} className="schedule" style={{ height: "240px" }}>
              <Box className="fx_sb_mob" pb={'4px'}>
                <Box className="">
                  <Typography variant="h6" className="col1 card_title ">
                    Step 3: Re-Scheduling of Scraper
                  </Typography>
                </Box>

                <Box>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={selectedOption}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="b"
                        control={<Radio />}
                        label="Using Date, Time & Frequency"
                      />
                      <FormControlLabel
                        value="a"
                        control={<Radio />}
                        label="Using Cron Expression"
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Box>
              <Divider />

              {selectedOption === "a" ? (
                <Box className="cron_expression" my={2}>
                  <Grid container justifyContent="center" spacing={1}>
                    <Grid item lg={12} md={8} sm={12} xs={12}>
                      <FormControl fullWidth className="input_field">
                        <FilledInput
                          id="filled-adornment-password"
                          placeholder="Enter Cron Expression"
                          value={cronexp || ""}
                          onChange={(event) => {
                            setCronExp(event.target.value);
                          }}
                          className="textfield_cron"
                        />
                      </FormControl>
                      <Box mt={1} className="al_left">
                        <Typography variant="h6" className="gray desc">
                          {" "}
                          Note: A cron expression is a string representing
                          a schedule in a time-based job scheduling system
                          (like Unix cron). It is typically made up of
                          five or six fields, separated by space, that
                          represent different units of time.
                        </Typography>

                        <Typography
                          variant="h6"
                          className="xstext"
                          mt={1}
                        >
                          {" "}
                          Example: A cron expression 0 12 * * Mon means
                          the task will run at 12:00 PM every Monday.
                          Learn more{" "}
                          <a
                            href="https://crontab.guru/"
                            className="a_underline"
                            target="_blank"
                          >
                            click here
                          </a>
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* <Box className="fx_c" mt={3} > */}
                  <Box className="bottom-fixed-stack">
                    <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="flex-end">
                      <Button
                        className="approve_btn"
                        disabled={!schedule}
                        onClick={() => {
                          setConfirmReschedulePopup(true);
                        }}
                      >
                        Re-schedule
                      </Button>

                      <Button
                        className="cancel_btn"
                        onClick={handleCloseRescheduleScraper}
                      >
                        Cancel
                      </Button>

                    </Stack>
                  </Box>
                </Box>
              ) : (
                <Schedule_Using_Date_Time_Frequency_2
                  urlid={urlid}
                  schedule_flag={schedule}
                  emp_code={session ? session.employeeCode : null}
                  job_id={currentJobId}
                  reschedule_flag={true}
                  freq_details={currentFreqdetails}
                  freq_type={currentFreqtype}
                  all_desc={ScheduleData}
                  version={version}

                  pageType="approved"
                  // allowed={ files.some((file) => file.status == "approved") &&
                  //   isLatestObjectCompleted(outputHistoryData)}
                  allowed={true}
                  onClickHandle={handleCloseRescheduleScraper}
                />
              )}
            </Box>
          </DialogContent>
        </Dialog>
        </Box>

        {/* Reschedule Modal */}
        <Box className="data preview">
        <Dialog
          open={confirmSchedulePopup}
          onClose={()=> {setConfirmSchedulePopup(false)}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Re-Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to schedule?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  schedulechroneAPI(cronexp);
                }}
                autoFocus
                className="approve_btn"
              >
                Schedule
              </Button>
            </Box>
            <Box>
              <Button onClick={()=> {setConfirmSchedulePopup(false)}} autoFocus className="cancel_btn">
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
        </Box>

        {/* Reschedule Modal Date Time Frequency*/}
        <Box className="data preview" >
        <Dialog
          open={confirmReschedulePopup}
          onClose={() => {setConfirmReschedulePopup(false)}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Re-Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to re-schedule ?
                </Typography>
              </Box>
              <Box className="fx_c" mb={2}>
                <Box mr={1}>
                  <Button
                    onClick={() => {
                      reschedulerAPI(cronexp);
                      setConfirmReschedulePopup(false);
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Re Schedule
                  </Button>
                </Box>
                <Box>
                  <Button onClick={() => {setConfirmReschedulePopup(false)}} autoFocus className="cancel_btn">
                    Cancel
                  </Button>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        </Box >

        {/* remove Scheduler alert dialog */}

        <Box className="data preview" >
        <Dialog
          open={disableSchedulerPopup}
          onClose={() => {
            setDisableSchedulerPopup(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={remove}
                      alt="remove"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to disable?
                </Typography>
              </Box>
              <Box className="fx_c" mb={2}>
                <Box mr={1}>
                  <Button
                    onClick={() => {
                      removeAPI_schedular();
                      setDisableSchedulerPopup(false);
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Ok
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      setDisableSchedulerPopup(false);
                    }}
                    autoFocus
                    className="cancel_btn"
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        </Box >
    </>
    );
};

export default SchedulingScrapers;